//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InputField from './InputField.vue'
import ValidationMessages from './ValidationMessages.vue'
import InputSelect from './InputSelect.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'InputGroup',
  components: {
    InputSelect,
    ValidationMessages,
    InputField
  },
  props: {
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    validation: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: String,
      default: null
    }
  },
  computed: {
    hasPrependSlot () {
      return !!this.$slots.prepend
    },

    hasAppendSlot () {
      return !!this.$slots.append
    }
  }
}
